import tw from "tailwind-styled-components";
import { capitalizeFirstLetter } from "../../../helpers";


const UtilityBillHeader = ({ selectedData, selectedOptionData }) => {
    if (!selectedOptionData) {
        return null;
    }

    return (
        <ProfileSection className="flex justify-between">
            <UserInfo>
                <span className="font-medium mb-0">
                    {capitalizeFirstLetter(selectedData?.name)}
                </span>
                <span className="text-sm text-gray-600">
                    {selectedData?.address}
                </span>
            </UserInfo>
        </ProfileSection>
    );
};

// Styled Components
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 p-4`;
const UserInfo = tw.div`flex flex-col`;

export default UtilityBillHeader;
